import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Татьяна Головко',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Ольга Упрямцева',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'Frontend-тимлид',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Дмитрий Муравьев',
            crewItemSubtitle: 'Backend-тимлид',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+6 программистов',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+2 DevOps-инженера',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+2 веб-дизайнера',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Контент-менеджер',
            crewItemSubtitle: '',
            color: true,
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="gapresource-team">
                <FullWrapper>
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
